import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "italic-button",
  "use": "italic-button-usage",
  "viewBox": "0 0 330.003 330.003",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 330.003 330.003\" id=\"italic-button\"><path d=\"M255.001 0h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h41.703l-54 270H75.001c-8.284 0-15 6.716-15 15s6.716 15 15 15h59.956c.02 0 .04.003.059.003.023 0 .045-.003.066-.003H195c8.284 0 15-6.716 15-15s-6.716-15-15-15h-41.703l54-270H255c8.284 0 15-6.716 15-15s-6.714-15-14.999-15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol